import { Button, Flex } from "@chakra-ui/react";
import { LocalDate } from "@js-joda/core";
import React from "react";

interface Props {
  startDate: LocalDate | null | undefined;
  endDate: LocalDate | null | undefined;
  onClick: (
    range: [LocalDate, LocalDate],
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  onClear: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const RangeDatePickerRanges = (props: Props) => {
  const ranges = React.useMemo(() => getRanges(LocalDate.now()), []);
  const isExactRange = ([start, end]: [LocalDate, LocalDate]) => {
    if (!props.startDate || !props.endDate) {
      return false;
    }

    return start.isEqual(props.startDate) && end.equals(props.endDate);
  };

  return (
    <Flex direction="column" gap={3}>
      {Object.entries(ranges).map(([name, range]) => {
        const isSelected = isExactRange(range);

        return (
          <Button
            key={name}
            _active={{
              bg: isSelected ? "blue.600" : "gray.50",
              borderColor: isSelected ? "blue.600" : "gray.300",
            }}
            _hover={{
              bg: isSelected ? "blue.600" : "gray.50",
              borderColor: isSelected ? "blue.600" : "gray.300",
            }}
            bg={isSelected ? "blue.500" : "#fff"}
            borderColor={isSelected ? "blue.500" : "gray.300"}
            borderRadius="6px"
            borderWidth="1px"
            color={isSelected ? "#fff" : "gray.700"}
            fontSize="13px"
            fontWeight={500}
            h="30px"
            minW="96px"
            size="sm"
            onClick={(e) => props.onClick(range, e)}
          >
            {name}
          </Button>
        );
      })}
      <Button
        _hover={{ bg: "gray.50" }}
        borderRadius="6px"
        color="gray.700"
        fontSize="13px"
        fontWeight={500}
        h="30px"
        minW="96px"
        size="sm"
        variant="ghost"
        onClick={props.onClear}
      >
        Clear
      </Button>
    </Flex>
  );
};

function getRanges(now: LocalDate): {
  [key: string]: [LocalDate, LocalDate];
} {
  return {
    "Last 7 days": [now.minusDays(7), now],
    "Last 14 days": [now.minusDays(14), now],
    "Last 30 days": [now.minusDays(30), now],
    "This month": [
      LocalDate.of(now.year(), now.month(), 1),
      LocalDate.of(now.year(), now.month(), now.lengthOfMonth()),
    ],
    "Last month": [
      now.minusMonths(1).withDayOfMonth(1),
      now.minusMonths(1).withDayOfMonth(now.minusMonths(1).lengthOfMonth()),
    ],
    "Last year": [now.minusYears(1), LocalDate.of(now.year() - 1, 12, 31)],
  };
}

export default RangeDatePickerRanges;
